import * as React from 'react';
import { createRoot } from 'react-dom/client';
import Client from './Client.js';


const root = createRoot(document.querySelector('#app'));

root.render(<Client />);
